export const exceptionSlugs = [
  "login",
  "register",
  "forgot-password",
  "reset-password",
  "product-detail",
  "catalog-detail",
  "category-detail",
  "brand-detail",
  "guest-order",
  "order-detail",
  "change-password",
  "success-payment",
  "cart-recover",
  "draft-order",
];
